import { FormArray, FormControl, UntypedFormGroup } from '@angular/forms';
import { EnumHelper } from 'mbs-ui-kit';
import { DayOfWeek } from 'wizards/models/DayOfWeek.enum';
import { WeekNumber } from 'wizards/models/WeekNumber.enum';

const defaultIncrementalWeekly = [false, true, true, true, true, true, false];
const defaultFullWeekly = [true, false, false, false, false, false, false];

const getSchedule = (isIncremental: boolean) => {
  const commonForm = {
    recurringPeriod: new FormControl<'Daily' | 'Monthly'>(isIncremental ? 'Daily' : 'Monthly'),
    dailyFreqPeriodOption: new FormControl<'OccursAt' | 'OccursEvery'>('OccursAt'),
    dayOfWeek: new FormControl<number>(3),
    dayOfMonthCount: new FormControl<number>(1),
    occurrence: new FormControl<number>(0),
    occursAtTime: new FormControl<string>('12:00'),
    weeklyDayOfWeek: new FormArray((isIncremental ? defaultIncrementalWeekly : defaultFullWeekly).map((v) => new FormControl<boolean>(v))),
    repeatEveryCount: new FormControl<number>(1),
    startFromDate: new FormControl<Date>(new Date())
  };
  const incrementalForm = {
    enabled: new FormControl<boolean>(true),
    occursEveryCount: new FormControl<number>(1),
    occursEveryPeriod: new FormControl<'hours' | 'minutes'>('hours'),
    occursEveryFromTime: new FormControl<string>('09:00'),
    occursEveryToTime: new FormControl<string>('21:00')
  };
  const fullForm = {
    enabled: new FormControl<boolean>(false)
  };

  return isIncremental ? { ...commonForm, ...incrementalForm } : { ...commonForm, ...fullForm };
};

const isSelectedDaysValidator = (formGroup: UntypedFormGroup, isNBF: boolean, isRestore: boolean) => {
  const isFFI = formGroup.value.ScheduleType === 'ffi';
  const isPredefined = formGroup.value.ScheduleType === 'predefined';

  if (isNBF && !isRestore && (isFFI || isPredefined)) {
    const incremental = formGroup.get('incrementalData') as UntypedFormGroup;
    const fullData = formGroup.get('fullBackupData') as UntypedFormGroup;
    const incErr = incremental.get('recurringPeriod').value === 'Daily' && !incremental.get('weeklyDayOfWeek').value.some((day) => !!day);
    const fullErr =
      fullData.get('enabled').value &&
      fullData.get('recurringPeriod').value === 'Daily' &&
      !fullData.get('weeklyDayOfWeek').value.some((day) => !!day);

    if (incErr) {
      return { needSelectDay: { message: isFFI ? 'Forever Forward Incremental' : 'recurring (incremental)', isFFI } };
    }

    if (fullErr) {
      return { needSelectDay: { message: 'Execute full backup (Synthetic full is possible)' } };
    }

    return null;
  }

  return null;
};

// TODO: Test
export { isSelectedDaysValidator };
export const getDefaultIncrementalSchedule = () => getSchedule(true);
export const getDefaultFullSchedule = () => getSchedule(false);
export const daysOfWeekEnumArray = EnumHelper.EnumToSelectIndexesArray(DayOfWeek);
export const weekNumberEnumArray = EnumHelper.EnumToSelectIndexesArray(WeekNumber).sort((a, b) => (a.label === WeekNumber[-1] ? -1 : 0));
